{ reportRavenError } = require 'base/lib/utils'
Translation = require 'components/mixins/translation'

contentResetKey = (content) ->
  return content.hashCode() if content?.hashCode?
  return content if _.isString content
  ''

EtdEditorErrorBoundary = createReactClass
  displayName: 'EtdEditorErrorBoundary'

  propTypes:
    cellId: PropTypes.string.isRequired
    children: PropTypes.node.isRequired
    content: PropTypes.oneOfType [
      PropTypes.instanceOf Immutable.Map
      PropTypes.string
    ]
    error: PropTypes.object

  mixins: [
    Translation('docsec:editor')
  ]

  getDefaultProps: ->
    content: null
    error: null

  getInitialState: ->
    error: null
    resetKey: contentResetKey @props.content

  componentDidUpdate: ->
    resetKey = contentResetKey @props.content
    return if resetKey is @state.resetKey
    @setState { error: null, resetKey }

  componentDidCatch: (error, errorInfo) ->
    reportRavenError error, extra: { cellId: @props.cellId, errorInfo }

  render: ->
    error = @props.error ? @state.error
    if error
      return <div className="etd-editor-error-boundary-fallback">
        <h3>{@i18n 'section_display_error'}</h3>
        <p>{@i18n 'contact_admin_for_help'}</p>
      </div>

    @props.children

EtdEditorErrorBoundary.getDerivedStateFromError = (error) ->
  { error }

module.exports = EtdEditorErrorBoundary
